import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

export const listItemMsg = (list, id, fallback = '') => ({
  id: `${list}_${id}`.toLowerCase(),
  defaultMessage: fallback,
});

export const formatListValue = props => {
  const { list, id, fallback, values, intl } = props;
  return intl.formatMessage(listItemMsg(list, id, fallback), values);
};

class FormattedListValue extends PureComponent {
  render() {
    return formatListValue(this.props);
  }
}

FormattedListValue.propTypes = {
  list: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fallback: PropTypes.string,
  values: PropTypes.shape({}),
  intl: intlShape.isRequired,
};
FormattedListValue.defaultProps = {
  fallback: '',
  values: {},
};

export default injectIntl(FormattedListValue);
